import {
  Container,
  Link,
  Stack,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'

import { useTranslation } from 'react-i18next'
import { Picture, TImage } from '@shared/ui'
import avantPng from './assets/AVANT.png'
import avantWebp from './assets/AVANT.webp'
import { ReactComponent as LinkedinIcon } from './assets/linkedin.svg'
import petrPng from './assets/Petr_Nentvich.png'
import petrWebp from './assets/Petr_Nentvich.webp'
import vadimPng from './assets/Vadim_Bilousov.png'
import vadimWebp from './assets/Vadim_Bilousov.webp'

interface IProps {
  sx?: SxProps
}

export function FundTeam({ sx }: IProps) {
  const theme = useTheme()

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  const { t } = useTranslation('widgets')

  const team: {
    name: string
    position: string
    imagePng: TImage<'png'>
    imageWebp: TImage<'webp'>
    linkedin: string
  }[] = [
    {
      name: t('main-page.fund-team.team.vadim.name'),
      position: t('main-page.fund-team.team.vadim.position'),
      imagePng: vadimPng as TImage<'png'>,
      imageWebp: vadimWebp as TImage<'webp'>,
      linkedin: 'https://www.linkedin.com/in/vadim-bilousov/',
    },
    {
      name: t('main-page.fund-team.team.petr.name'),
      position: t('main-page.fund-team.team.petr.position'),
      imagePng: petrPng as TImage<'png'>,
      imageWebp: petrWebp as TImage<'webp'>,
      linkedin: 'https://www.linkedin.com/in/petr-nentvich-8243921b/',
    },
    {
      name: t('main-page.fund-team.team.avant.name'),
      position: t('main-page.fund-team.team.avant.position'),
      imagePng: avantPng as TImage<'png'>,
      imageWebp: avantWebp as TImage<'webp'>,
      linkedin: 'https://www.linkedin.com/company/avant-investicni-spolecnost',
    },
  ]

  return (
    <Container maxWidth="lg" sx={sx} id="fund-team">
      <Stack gap={5}>
        <Typography variant="h2">{t('main-page.fund-team.title')}</Typography>

        <Stack
          flexDirection={{ xs: 'column', sm: 'row' }}
          gap={{ xs: '44px', md: '60px' }}
        >
          {team.map((item) => (
            <Stack key={item.name} gap={{ xs: '16px', md: '20px' }}>
              <Picture
                png={item.imagePng}
                webp={item.imageWebp}
                alt={item.name}
              />

              <Stack
                flexDirection={{ xs: 'column', md: 'row' }}
                gap={{ xs: '12px', md: '15px' }}
                justifyContent="space-between"
              >
                <Stack gap={{ xs: '2px', md: '4px' }}>
                  <Typography
                    variant={isDesktop ? 'text18Bold' : 'text16Semibold'}
                  >
                    {item.name}
                  </Typography>

                  <Typography
                    variant={isDesktop ? 'text16Regular' : 'text15Regular'}
                  >
                    {item.position}
                  </Typography>
                </Stack>

                <Link href={item.linkedin} target="_blank">
                  <LinkedinIcon />
                </Link>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Container>
  )
}
